import { render } from "./WorkAdmin.vue?vue&type=template&id=34709542"
import script from "./WorkAdmin.vue?vue&type=script&lang=js"
export * from "./WorkAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__